import {Component, OnInit, ViewChildren, ElementRef, QueryList} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import * as _ from 'lodash';

import { Resume, OptionalField } from '../../interfaces/interfaces';
import { ResumeService } from '../../services/resume.service';
import { AuthService } from '../../../core/services/auth.service';
import { UtilService } from 'src/app/shared/services/util.service';

@Component({
  selector: 'app-add-others',
  templateUrl: './add-others.component.html',
  styleUrls: ['./add-others.component.css']
})
export class AddOthersComponent implements OnInit {
  public resume: Resume = {} as Resume;
  public valueStack: any;
  public field_name; string;
  public optionalField: OptionalField = {} as OptionalField;
  public optionalFields: [any];
  public descs = [
    '<div class="titleAdd__body">Overview the processes of the company functioning</div>',
    '<div class="titleAdd__body">Enterprise grade machine learning platform for auto-updating while the grade machine learning platform for auto-updating. Enterprise grade machine learning platform for auto-updating.</div>',
    '<div class="titleAdd__body">Enterprise grade machine learning platform for auto-updating. Enterprise grade machine learning platform for auto-updating.</div>',
    '<div class="titleAdd__body">Overview the processes of the company functioning</div>',
    '<div class="titleAdd__body">Enterprise grade machine learning platform for auto-updating. Enterprise grade machine learning platform for auto-updating.</div>',
    '<div class="titleAdd__body">Implemented multiple predictive models and clustering to cross-sell high profit LAP (loan against property) to current clients. </div>'
  ];
  @ViewChildren('resumeTemplate') template: QueryList<ElementRef>;
  constructor(
    private router: Router,
    private authService: AuthService,
    private resumeService: ResumeService,
    private localStorageService: LocalStorageService,
    private route: ActivatedRoute,
    public utilService: UtilService
  ) {
    const resume_id = this.localStorageService.get('resume_id');
    if (resume_id) {
      this.resumeService.getResumeById(resume_id).subscribe(res => {
        this.valueStack = res;
        this.resume = res.Resume;
        this.optionalFields = res.OptionalField || [];
        this.route.queryParams.subscribe(params => {
          this.field_name = params.f;
        });
        this.optionalField =
          _.sortBy(this.optionalFields, [this.field_name])[0] as OptionalField || {name: this.field_name} as OptionalField;
      });
    }
  }

  addNext() {
    this.optionalField.resume_id = this.resume.id;
    this.resumeService.addOptional(this.optionalField).subscribe(res => {
      this.skip();
    });
  }
  editNext() {
    this.resumeService.editOptional(this.optionalField).subscribe(res => {
      this.skip()
    });
  }
  append(model, html) {
    if (!model.value) {
      model.value = '';
    }
    model.value += html;
  }

  ngOnInit() {
  }
  skip () {
    const theme_id = this.localStorageService.get('theme_id') as string || 1;
    this.router.navigate(['/themes/' + theme_id]);
  }
  goToTheme () {
    const theme_id = this.localStorageService.get('theme_id') as string || 1;
    this.router.navigate(['/themes/' + theme_id]);
  }

}
